<p>sale-card works!</p>
